// eslint-disable-next-line
import React from 'react';

import { Spinner } from '@cb/apricot-react';

type AmountCheckedDisplayProps = {
  amountSelected?: number;
  endDisplayIndex?: number;
  itemsPerPage?: number;
  showSelected?: boolean;
  startDisplayIndex?: number;
  tableName?: string;
  totalCount?: number;
  loading?: boolean;
};

function AmountCheckedDisplay({
  amountSelected = 0,
  endDisplayIndex = 0,
  itemsPerPage = 30,
  showSelected = false,
  startDisplayIndex = 0,
  tableName = '',
  totalCount = 0,
  loading = false,
}: AmountCheckedDisplayProps) {
  return (
    <div
      id='amount-checked'
      style={{ fontSize: '1rem' }}
      aria-atomic='true'
      aria-live='polite'
      className='cb-float-left display-flex align-items-center'
    >
      {loading ? <Spinner size='16' className='cb-margin-right-8' /> : null}
      <span className='cb-sr-only'>{tableName} table currently </span>
      Displaying{' '}
      {totalCount < itemsPerPage
        ? totalCount
        : `${
            startDisplayIndex === endDisplayIndex ? 1 : `${startDisplayIndex}-${endDisplayIndex}`
          } of ${totalCount}`}{' '}
      result{totalCount === 1 ? '' : 's'}
      {showSelected ? ` (${amountSelected} selected)` : ''}
    </div>
  );
}

export default AmountCheckedDisplay;
